import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  disableButton() {
    this.element.style.pointerEvents = 'none';
    setTimeout(() => {
      $(this.element).prop('disabled', true);
    }, 0);
  }

  connect() {
    this.element.style.pointerEvents = 'auto';
    $(this.element).prop('disabled', false);
  }
}
